export const en = {
  title: 'Guild war reporting',
  darkMode: 'Dark Mode',
  tower: 'Name of the tower or player...',
  t1: 'T1',
  t2: 'T2',
  report: 'Report',
  firstHero: 'Your first hero',
  speed: 'Speed',
  speedimprint: 'Speed imprint',
  hp: 'HP',
  cr: '% CR',
  outspeed: 'Outspeed?',
  outspeedDesc: 'Is he play before me?',
  extraInfos: 'Extra infos...',
  heroesSaved: 'Heroes/speeds are saved locally',
  copyText: 'Copy text to clipboard',
  copyTextSL: 'Copy text to clipboard(Single line)',
  reset: 'Reset form',
  copyToast: 'Text copied!',
  resetToast: 'Form has been reseted!',
  enemiesFirstHero: 'First hero',
  enemiesSecondHero: 'Second hero',
  enemiesThirdHero: 'Third hero',
  enemiesFirstArtifact: 'First artifact',
  enemiesSecondArtifact: 'Second artifact',
  enemiesThirdArtifact: 'Third artifact',
  setCounter: 'Counter set',
  setImmunity: 'Immunity set',
  formatHpK: 'k',
  crBonus: '% CR Push back',
  crBonusDesc: 'Example : 30 if basar play before you',
  crPush: '% CR Push',
  crPushDesc: 'Example : 25 if rose play before you',
  crPushAlly: '% CR Push for allies',
  crPushAllyDesc: 'Example : 15 if your general purgis attacked by enemies',
};
